namespace SolovisGateway.Admin.DbServers {

    /**
     * EditDbServerDialog presents the user interface for adding or editing database servers.
     */
    export class EditDbServerDialog {

        private _dbServerId;
        private _saveCallback;

        private _formBuilder: Solovis.UI.InputControls.FormBuilder;
        private _dialog: Solovis.UI.Dialog;

        private _dbServerInfo;

        constructor(options) {
            this._dbServerId = options.dbServerId;
            this._saveCallback = options.saveCallback;
        } 

        public show() {
            let self = this;

            if (this._dbServerId) {
                Solovis.Rpc.invokeAndWait(
                    "~/Admin/DbServerAdmin/GetDbServerInfo",
                    { dbServerId: this._dbServerId, includeConnectionString: true },
                    function (response, success) {
                        if (success) {
                            self._dbServerInfo = response.result.dbServer;
                            self._internalShow();
                        }
                    });
            }
            else {
                this._internalShow();
            }
        }

        public _internalShow() {

            let formBuilderDiv = $("<div>");
            let formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formBuilderDiv
            });
            this._formBuilder = formBuilder;

            formBuilder.addEntry({
                name: "server",
                label: "Server",

                initialValue: this._dbServerInfo ? this._dbServerInfo.server : null,

                editor: {
                    type: "text",
                    textOptions: {
                        maxLength: 512
                    }
                }
            });

            formBuilder.addEntry({
                name: "masterConnectionString",
                label: "Master Connection String",

                initialValue: this._dbServerInfo ? this._dbServerInfo.masterConnectionString : null,

                editor: {
                    type: "textarea",
                    textareaOptions: {
                        width: 500,
                        height: 150
                    }
                }
            });

            this._dialog = formBuilder.showAsDialog({
                title: this._dbServerId ? "Edit Database Server" : "Add Database Server",
                desiredWidth: 700,
                desiredHeight: 400,
                modal: true,

                showSaveCancel: true,
                saveCallback: () => {
                    this._save();
                    return false;
                }
            });
        }

        public _save() {
            let self = this;

            let server = this._formBuilder.getValueByName("server");
            let masterConnectionString = this._formBuilder.getValueByName("masterConnectionString");

            Solovis.Rpc.invokeAndWait(
                "~/Admin/DbServerAdmin/EditDbServer",
                {
                    model: {
                        dbServerId: this._dbServerId,
                        server: server,
                        masterConnectionString: masterConnectionString
                    }
                },
                function (response, success) {
                    if (success) {
                        var result = response.result;
                        if (result) {
                            if (result && result.modelResult && result.modelResult.dbServerId) {
                                self._dialog.close();

                                if (self._saveCallback) {
                                    self._saveCallback();
                                }                                

                                if (!result.modelResult.connectSuccess) {
                                    Solovis.UI.alert("Failed to connect to database server.", "Warning");
                                }
                            }
                            else {
                                if (response.result.errors) {
                                    self._formBuilder.applyErrors(response.result.errors);
                                }
                            }
                        }
                    }
                });
        }
    }


}